import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../common/navbar/navbar.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2'; // <-- 1. Import SweetAlert

interface Lesson {
  title: string;
  summary: string;
  videoUrl: string;
}

interface CourseType {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  focus: string[];
  lessons: Lesson[];
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, NavbarComponent],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  private sanitizer = inject(DomSanitizer);

  categories: CourseType[] = [
    {
      id: 'finnish-sinhala',
      title: 'Basic Finnish Language Course - Sinhala',
      subtitle: 'Grammar, Writing & Speaking',
      description: 'Start learning Finnish fundamentals with practical lessons that build speaking, reading, and writing confidence.',
      focus: ['Complete vocabulary drills', 'Practice sentence structure', 'Review common phrases'],
      lessons: [
        {
          title: 'Introduction',
          summary: 'Introduction of lecturer, How to learn a new language, Advantages of Finnish language , YKI tesk , Testimony of students, Basic greetings',
          videoUrl: 'https://drive.google.com/file/d/1KF7y3RVGUQx6oF6GZ57HhLnoJLhjG-Oz/preview'
        },
        {
          title: 'Finnish Alphabet',
          summary: 'Sounds of alphabet and pronunciation. Sinhala, English and Finnish.',
          videoUrl: 'https://drive.google.com/file/d/1jjlMve_YKwjC3IvfLz3M688N5SaRFylL/preview'
        },
        {
          title: 'Finnish Alphabet/2',
          summary: 'Sounds of alphabet and pronunciation. Sinhala, English and Finnish',
          videoUrl: 'https://drive.google.com/file/d/1iofBTxCOVZJK_I9pw2hVMQVHnKqQl61a/preview'
        },
        {
          title: '“Be Verb -Olla”',
          summary: 'Days , Numbers , vowels and Olla verb.',
          videoUrl: 'https://drive.google.com/file/d/1jRSdfFgbw_TK8DC2LkEb09-NUc5QdyU7/preview'
        },
        {
          title: 'Practice of Olla verb and numbers',
          summary: 'Reading , numbers , Kahoot game,',
          videoUrl: 'https://drive.google.com/file/d/1TextZn6SztOG_6efsiTJV2MluiYYlOL7/preview'
        },
        {
          title: 'KPT Theory/ Verb Type 1',
          summary: 'Practice of KPT, Verb Type 1, languages, countries and introductions of you.',
          videoUrl: 'https://drive.google.com/file/d/1IFuK0woxCB3GLk3OkFkAnhBd3wYt6m_O/preview'
        },
        {
          title: 'How to ask price',
          summary: 'Practice of Verb type 1, Reading, creating a question, W words,',
          videoUrl: 'https://drive.google.com/file/d/1Zwu_woKh0bl3gvawPvfkm2b_wMWqQ456/preview'
        },
        {
          title: 'Finland Weather',
          summary: 'Practice of plural, ownership, Reading, adjectives',
          videoUrl: 'https://drive.google.com/file/d/18Jp-5NCuu3YqtrFjzt65P8dqmjZsIY9s/preview'
        },
        {
          title: 'Finland Weather/2',
          summary: 'Personal information, Reading , Weather',
          videoUrl: 'https://drive.google.com/file/d/1ivVq9JK4Acx8Xy33S2we3n2OQ5_8jZar/preview'
        },
        {
          title: 'Partitiivi',
          summary: 'Partitiivi making and usage, Kahoot game',
          videoUrl: 'https://drive.google.com/file/d/1YIuvSxTrDDfqKjGOefKfT0cJopLCSE42/preview'
        },
        {
          title: 'Colors/ introductions of a person.',
          summary: 'revision of partitiivi, family, practice of colors with Kahoot, cloths.',
          videoUrl: 'https://drive.google.com/file/d/1HUqDYv6eJldkPzxXMlrCz6oQKaTAQ_TR/preview'
        },
        {
          title: 'My Self',
          summary: 'Reading and partitiivi practice',
          videoUrl: 'https://drive.google.com/file/d/1b5I6DoBEIJtekcdeEZVKnfylKzZRaqMK/preview'
        },
        {
          title: 'Verb Type 1,2,3,4,5',
          summary: 'Kahoot game practices for verbs',
          videoUrl: 'https://drive.google.com/file/d/1_0Symp9N7A21m9fZT-2-aPxCubEHnrIA/preview'
        },
        {
          title: 'Finnish Notmal Day',
          summary: 'verb+ Verb sentences, verb+ partitiivi',
          videoUrl: 'https://drive.google.com/file/d/16NAq9gm7fERNmHqTKjvAGREBQteBZ_xd/preview'
        },
        {
          title: 'locations',
          summary: 'how to creat location by adding endings ssa, sta, lle, lla, lta., time practice',
          videoUrl: 'https://drive.google.com/file/d/1cjCurOKH_L4lK9hGOYKZGFHp7aAWmdLK/preview'
        },
        {
          title: 'Commanding and Reading',
          summary: 'practice locations, adjectives, home items',
          videoUrl: 'https://drive.google.com/file/d/1TMqW2NOd-tGrmCt03ISkaYJx777x9I8U/preview'
        },
        {
          title: 'Sanatyypit',
          summary: 'words type normal, e , nen and i, Reading practices',
          videoUrl: 'https://drive.google.com/file/d/1qcis_zFsn4dvz9plK6lhMtctNnvoipWX/preview'
        },
        {
          title: 'Reading',
          summary: 'Kahoot game for vehicles, Finnish village',
          videoUrl: 'https://drive.google.com/file/d/1U7vq05VbZ1dDUYZrEnW2kwAP5Sj4lVq_/preview'
        },
        {
          title: 'Ainasanat Partitiivi',
          summary: 'Usage of Partitiivi with ainasanat , around , behind , Infront of , center, under, near, on propositions',
          videoUrl: 'https://drive.google.com/file/d/1ugkQGYuGVOhAvSnd3Wr3pob0O9_5MPSN/preview'
        },
        {
          title: 'Foods',
          summary: 'Reading and Excersice,',
          videoUrl: 'https://drive.google.com/file/d/1SciEjANFtso0ABDXeMtvT8UT36FDgtsL/preview'
        },
        {
          title: 'Continue of sanatyypit/ Professions',
          summary: 'Kahoot game for mix theory and professions',
          videoUrl: 'https://drive.google.com/file/d/1X3-a5JoDFjSoEGOFg88CdxLggOD-O1Do/preview'
        },
        {
          title: 'Revision of A1 level of Finnish',
          summary: 'Frasit, days, months , numbers, KPT, Partitiivi, Verb types, sanatyypit…',
          videoUrl: 'https://drive.google.com/file/d/1ZtGiSC1aC5szmLoVal6P6XebTAUxbFDn/preview'
        }
      ]
    },
    // {
    //   id: 'finnish-english',
    //   title: 'Basic Finnish Language Course - English',
    //   subtitle: 'Grammar, Writing & Speaking',
    //   description: 'Start learning Finnish fundamentals with practical lessons that build speaking, reading, and writing confidence.',
    //   focus: ['Complete vocabulary drills', 'Practice sentence structure', 'Review common phrases'],
    //   lessons: [
    //     {
    //       title: 'Introduction',
    //       duration: '20 min',
    //       summary: 'Introduction of lecturer, How to learn a new language, Advantages of Finnish language , YKI tesk , Testimony of students, Basic greetings',
    //       videoUrl: 'https://drive.google.com/file/d/1KF7y3RVGUQx6oF6GZ57HhLnoJLhjG-Oz/preview'
    //     },
    //     {
    //       title: 'Finnish Alphabet',
    //       duration: '15 min',
    //       summary: 'Sounds of alphabet and pronunciation. Sinhala, English and Finnish.',
    //       videoUrl: 'https://drive.google.com/file/d/1jjlMve_YKwjC3IvfLz3M688N5SaRFylL/preview'
    //     },
    //     {
    //       title: 'Finnish Alphabet/2',
    //       duration: '20 min',
    //       summary: 'Sounds of alphabet and pronunciation. Sinhala, English and Finnish',
    //       videoUrl: 'https://drive.google.com/file/d/1iofBTxCOVZJK_I9pw2hVMQVHnKqQl61a/preview'
    //     },
    //     {
    //       title: '“Be Verb -Olla”',
    //       duration: '15 min',
    //       summary: 'Days , Numbers , vowels and Olla verb.',
    //       videoUrl: 'https://drive.google.com/file/d/1jRSdfFgbw_TK8DC2LkEb09-NUc5QdyU7/preview'
    //     },
    //     {
    //       title: 'Practice of Olla verb and numbers',
    //       duration: '20 min',
    //       summary: 'Reading , numbers , Kahoot game,',
    //       videoUrl: 'https://drive.google.com/file/d/1TextZn6SztOG_6efsiTJV2MluiYYlOL7/preview'
    //     },
    //     {
    //       title: 'KPT Theory/ Verb Type 1',
    //       duration: '15 min',
    //       summary: 'Practice of KPT, Verb Type 1, languages, countries and introductions of you.',
    //       videoUrl: 'https://drive.google.com/file/d/1IFuK0woxCB3GLk3OkFkAnhBd3wYt6m_O/preview'
    //     },
    //     {
    //       title: 'How to ask price',
    //       duration: '20 min',
    //       summary: 'Practice of Verb type 1, Reading, creating a question, W words,',
    //       videoUrl: 'https://drive.google.com/file/d/1Zwu_woKh0bl3gvawPvfkm2b_wMWqQ456/preview'
    //     },
    //     {
    //       title: 'Finland Weather',
    //       duration: '20 min',
    //       summary: 'Practice of plural, ownership, Reading, adjectives',
    //       videoUrl: 'https://drive.google.com/file/d/18Jp-5NCuu3YqtrFjzt65P8dqmjZsIY9s/preview'
    //     },
    //     {
    //       title: 'Finland Weather/2',
    //       duration: '20 min',
    //       summary: 'Personal information, Reading , Weather',
    //       videoUrl: 'https://drive.google.com/file/d/1ivVq9JK4Acx8Xy33S2we3n2OQ5_8jZar/preview'
    //     },
    //     {
    //       title: 'Partitiivi',
    //       duration: '20 min',
    //       summary: 'Partitiivi making and usage, Kahoot game',
    //       videoUrl: 'https://drive.google.com/file/d/1YIuvSxTrDDfqKjGOefKfT0cJopLCSE42/preview'
    //     },
    //     {
    //       title: 'Colors/ introductions of a person.',
    //       duration: '20 min',
    //       summary: 'revision of partitiivi, family, practice of colors with Kahoot, cloths.',
    //       videoUrl: 'https://drive.google.com/file/d/1HUqDYv6eJldkPzxXMlrCz6oQKaTAQ_TR/preview'
    //     },
    //     {
    //       title: 'My Self',
    //       duration: '20 min',
    //       summary: 'Reading and partitiivi practice',
    //       videoUrl: 'https://drive.google.com/file/d/1b5I6DoBEIJtekcdeEZVKnfylKzZRaqMK/preview'
    //     },
    //     {
    //       title: 'Verb Type 1,2,3,4,5',
    //       duration: '20 min',
    //       summary: 'Kahoot game practices for verbs',
    //       videoUrl: 'https://drive.google.com/file/d/1_0Symp9N7A21m9fZT-2-aPxCubEHnrIA/preview'
    //     },
    //     {
    //       title: 'Finnish Notmal Day',
    //       duration: '20 min',
    //       summary: 'verb+ Verb sentences, verb+ partitiivi',
    //       videoUrl: 'https://drive.google.com/file/d/16NAq9gm7fERNmHqTKjvAGREBQteBZ_xd/preview'
    //     },
    //     {
    //       title: 'locations',
    //       duration: '20 min',
    //       summary: 'how to creat location by adding endings ssa, sta, lle, lla, lta., time practice',
    //       videoUrl: 'https://drive.google.com/file/d/1cjCurOKH_L4lK9hGOYKZGFHp7aAWmdLK/preview'
    //     },
    //     {
    //       title: 'Commanding and Reading',
    //       duration: '20 min',
    //       summary: 'practice locations, adjectives, home items',
    //       videoUrl: 'https://drive.google.com/file/d/1TMqW2NOd-tGrmCt03ISkaYJx777x9I8U/preview'
    //     },
    //     {
    //       title: 'Sanatyypit',
    //       duration: '20 min',
    //       summary: 'words type normal, e , nen and i, Reading practices',
    //       videoUrl: 'https://drive.google.com/file/d/1qcis_zFsn4dvz9plK6lhMtctNnvoipWX/preview'
    //     },
    //     {
    //       title: 'Reading',
    //       duration: '20 min',
    //       summary: 'Kahoot game for vehicles, Finnish village',
    //       videoUrl: 'https://drive.google.com/file/d/1U7vq05VbZ1dDUYZrEnW2kwAP5Sj4lVq_/preview'
    //     },
    //     {
    //       title: 'Ainasanat Partitiivi',
    //       duration: '20 min',
    //       summary: 'Usage of Partitiivi with ainasanat , around , behind , Infront of , center, under, near, on propositions',
    //       videoUrl: 'https://drive.google.com/file/d/1ugkQGYuGVOhAvSnd3Wr3pob0O9_5MPSN/preview'
    //     },
    //     {
    //       title: 'Foods',
    //       duration: '20 min',
    //       summary: 'Reading and Excersice,',
    //       videoUrl: 'https://drive.google.com/file/d/1SciEjANFtso0ABDXeMtvT8UT36FDgtsL/preview'
    //     },
    //     {
    //       title: 'Continue of sanatyypit/ Professions',
    //       duration: '20 min',
    //       summary: 'Kahoot game for mix theory and professions',
    //       videoUrl: 'https://drive.google.com/file/d/1X3-a5JoDFjSoEGOFg88CdxLggOD-O1Do/preview'
    //     },
    //     {
    //       title: 'Revision of A1 level of Finnish',
    //       duration: '15 min',
    //       summary: 'Frasit, days, months , numbers, KPT, Partitiivi, Verb types, sanatyypit…',
    //       videoUrl: 'https://drive.google.com/file/d/1ZtGiSC1aC5szmLoVal6P6XebTAUxbFDn/preview'
    //     }
    //   ]
    // },
    {
      id: 'finnish-institute',
      title: 'Basic Finnish Language Course - Institute',
      subtitle: 'Grammar, Writing & Speaking',
      description: 'Start learning Finnish fundamentals with practical lessons that build speaking, reading, and writing confidence.',
      focus: ['Complete vocabulary drills', 'Practice sentence structure', 'Review common phrases'],
      lessons: [
        {
          title: 'Day 01',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1NaCy47XRR9nmx9GTNcuyhB77gnW81ias/preview'
        },
        {
          title: 'Day 02',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1vJfE1Zb-CtxnBcI1-25C8Py4CyAp-2-B/preview'
        },
        {
          title: 'Day 03',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1RMXe1YSRfKDYDjmVV3JeruscSk7MaPRs/preview'
        },
        {
          title: 'Day 04',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1fGI87vV2NJCAFYL5Qlw_PrcYfPm87Ait/preview'
        },
        {
          title: 'Day 05',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1fGI87vV2NJCAFYL5Qlw_PrcYfPm87Ait/preview'
        },
        {
          title: 'Day 06',
          summary: '',
          videoUrl: 'https://drive.google.com/file/d/1-fmLXWMCVVJQoUT7XaNmFppa47w9Is5p/preview'
        }
      ]
    }
  ];

  selectedCategory: CourseType = this.categories[0];
  selectedLessonIndex = 0;

  get currentLesson(): Lesson | undefined {
    return this.selectedCategory.lessons[this.selectedLessonIndex];
  }

  get currentLessonVideoUrl(): SafeResourceUrl | undefined {
    const lesson = this.currentLesson;
    if (!lesson) {
      return undefined;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(lesson.videoUrl);
  }

  selectCategory(category: CourseType): void {
    this.selectedCategory = category;
    this.selectedLessonIndex = 0;

    // Alert when the user selects a new category
    const firstLesson = category.lessons[0];
    if (firstLesson) {
      this.showVideoAlert(firstLesson.title);
    }
  }

  selectCategoryAndLesson(category: CourseType, index: number): void {
    this.selectedCategory = category;
    if (index >= 0 && index < category.lessons.length) {
      this.selectedLessonIndex = index;
      this.showVideoAlert(category.lessons[index].title); // <-- Trigger Alert
    }
  }

  selectLesson(index: number): void {
    if (index >= 0 && index < this.selectedCategory.lessons.length) {
      this.selectedLessonIndex = index;
      this.showVideoAlert(this.selectedCategory.lessons[index].title); // <-- Trigger Alert
    }
  }

  // Helper method to display a custom Toast alert for loading a video
  private showVideoAlert(lessonTitle: string): void {
    Swal.fire({
      title: 'Loading Video...',
      text: `Now playing: "${lessonTitle}"`,
      icon: 'success',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      toast: true,
      position: 'top-end',
      background: '#d1e7dd',
      color: '#0f5132',
      iconColor: '#198754',
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }
    });
  }
}